import { environment } from 'src/environments/environment';
import { UserRole } from '../shared/auth.roles';
const adminRoot = environment.adminRoot;

export interface IMenuItem {
  id?: string;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
  roles?: UserRole[];
}

const data: IMenuItem[] = [
  {
    icon: 'iconsminds-bell',
    label: 'menu.news',
    to: `${adminRoot}/aviso`,
  },
  {
    icon: 'iconsminds-billing',
    label: 'menu.accounts',
    to: `${adminRoot}/balance`,
  },
  {
    icon: 'iconsminds-notepad',
    label: 'menu.notas',
    to: `${adminRoot}/notas`,
  },
  {
    icon: 'iconsminds-calendar-4',
    label: 'menu.actividades',
    to: `${adminRoot}/actividades`,
  },
  {
    icon: 'iconsminds-student-hat',
    label: 'menu.student',
    to: `${adminRoot}/account`,
  },
  {
    icon: 'simple-icon-clock',
    label: 'menu.schedule',
    to: `${adminRoot}/schedule`,
  },  
  {
    icon: 'iconsminds-letter-open',
    label: 'menu.dte',
    to: `${adminRoot}/dte`,
  }
];

export default data;
